import styled from "styled-components";

export const StyledServiceNoteCell = styled.div`
    border-bottom: 1px solid #bbb;
    margin: 9px 0px;
`;